import { Model } from "@bryntum/schedulerpro";
import { HasProjectMixin } from "./mixins/HasProjectMixin";

export type MarketingDocumentFormat = "docx" | "pdf";

export class MarketingDocument extends HasProjectMixin(Model) {

  declare id: number;
  declare board: number;
  declare workFile: number | null;
  declare format: MarketingDocumentFormat;
  declare title: string;
  declare filename: string;
  declare file: number | null;
  declare fileId: number | null;
  declare downloadUrl: string;
  declare createdAt: Date;
  declare updatedAt: Date;
  declare creator: number | null;
  declare updater: number | null;

  static get $name() {
    return "MarketingDocument";
  }

  static get fields() {
    return [
      "id",
      "board",
      { name: "workFile", dataSource: "work_file", type: "number" },
      "format",
      "title",
      "filename",
      { name: "file", type: "number" },
      { name: "fileId", dataSource: "file_id", type: "number" },
      { name: "downloadUrl", dataSource: "download_url" },
      { name: "createdAt", dataSource: "created_at", type: "date" },
      { name: "updatedAt", dataSource: "updated_at", type: "date" },
      { name: "creator", type: "number" },
      { name: "updater", type: "number" },
    ];
  }

  get displayTitle(): string {
    return this.title?.trim() || this.filename?.trim() || "Untitled document";
  }

  get boardFileId(): number | null {
    return this.fileId ?? this.file ?? null;
  }
}

// @ts-expect-error - exposeProperties is internal method
MarketingDocument.exposeProperties();
